function fullPageMap(map){

    map.getMapContainer().addClass('fullPageMap');
    $('body').addClass('hideScroll');

}

function fullMap(map, typeMin){

    map.mapContainer.addClass('fullMap');

    $('body').addClass('hideScroll');

    let closeBtn = $('<button class="crossMap" type="button"><i class="icon-cross"></i></button>');
    map.mapContainer.prepend(closeBtn);

    history.pushState({ modalOpen: true }, null, "#map");

    const closeMap = function(){

        if(window.location.hash === "#map"){
            history.back();
        }

        closeBtn.remove();
        $('body').removeClass('hideScroll');
        if (typeMin && typeMin === 'remove') {
            map.mapContainer.remove();
        } else {
            minimizeMap(map);
        }
    }

    window.onpopstate = function(){
        closeMap();
    }

    closeBtn.on('click', closeMap);

}

function minimizeMap(map){
    map.mapContainer.removeClass('fullMap');
}

export {fullMap, fullPageMap, minimizeMap}